import { SignOut, X } from "@phosphor-icons/react";
import { type JSX, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import { useAuth } from "common/context/AuthContext";
import useGTM from "common/hooks/useGTM";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import useWorkspaceNavigate from "common/hooks/useWorkspaceNavigate";

import AimfoxLogo from "assets/aimfoxLogos/aimfox-logo-text.svg?react";

export default function BaseLayout() {
  const isDesktop = useTwBreakpoint("lg");
  const { goBackToWorkspace } = useWorkspaceNavigate();
  const { pathname } = useLocation();
  const { sendEvent } = useGTM();
  const { logout } = useAuth();

  useEffect(() => {
    sendEvent("virtualPageView", () => ({
      pageUrl: window.location.href,
      pagePath: pathname,
    }));
  }, []);

  let buttonComponent: JSX.Element;
  if (pathname.includes("onboarding")) {
    buttonComponent = isDesktop ? (
      <Button variant="secondary-black" onClick={logout} leftIcon={<SignOut />}>
        Log out
      </Button>
    ) : (
      <Button
        intent="iconOnly"
        size="lg"
        variant="secondary-black"
        onClick={logout}
      >
        <SignOut />
      </Button>
    );
  } else {
    buttonComponent = (
      <Button
        intent="iconOnly"
        size="lg"
        variant="outline-black"
        onClick={goBackToWorkspace}
        className="lg:hidden"
      >
        <X />
      </Button>
    );
  }

  return (
    <>
      <header className="flex h-20 items-center justify-between px-4 bg-white max-lg:shadow-sm relative">
        <AimfoxLogo />
        {buttonComponent}
      </header>

      <main className="bg-white flex flex-col lg:pt-1 p-4 min-h-[calc(100dvh-80px)]">
        <Outlet />
      </main>
    </>
  );
}
